import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider, OAuthProvider  } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.AIVA_WEB_FIREBASE_API_KEY,
  authDomain: process.env.AIVA_WEB_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.AIVA_WEB_FIREBASE_PROJECT_ID,
  storageBucket: process.env.AIVA_WEB_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.AIVA_WEB_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.AIVA_WEB_FIREBASE_APP_ID
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
// Cache documents on the device so repeat visits paint from IndexedDB while the server syncs.
export const db = initializeFirestore(app, {
  localCache: typeof window === 'undefined' ? memoryLocalCache() : persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// Set persistence to long-term (local)
(async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (error) {
    console.error("Error setting Firebase persistence:", error);
  }
})();


export default app;